
























import Vue, { VueConstructor } from 'vue'
import { mapState } from 'vuex'
import { ChordProgressionChord } from '../application/models/chordProgression'
import hasChordProgression, { HasChordProgressionMixinData } from '@/mixins/hasChordProgression'
import hasScaleInKey, { HasScaleInKeyMixinData } from '@/mixins/hasScaleInKey'
import hasEnharmonics, { HasEnharmonicsMixinData } from '@/mixins/hasEnharmonics'

type Mixins = HasChordProgressionMixinData & HasScaleInKeyMixinData & HasEnharmonicsMixinData

export default (Vue as VueConstructor<Mixins>).extend({
  mixins: [hasChordProgression, hasScaleInKey, hasEnharmonics],
  computed: {
    ...mapState('chordProgression', [
      'progressionName'
    ])
  },
  methods: {
    getChordNumeral(chordProgressionChord: ChordProgressionChord) {
      const chord = chordProgressionChord.getChord(this.scaleInKey, this.isFlats)
      return chord.chordNumeral
    },
    getChordSymbol(chordProgressionChord: ChordProgressionChord) {
      const chord = chordProgressionChord.getChord(this.scaleInKey, this.isFlats)
      return chord.chordSymbol
    }
  }
})
